import * as ANS from './action-names.js'
import { createCommitEditReducer, createPasteDataReducer } from './utils'

export const selecting = (state = false, action) => {
  switch (action.type) {
    case ANS.SELECTION_STARTS:
      return true
    case ANS.SELECTION_ENDS:
      return false
  }
  return state
}

export const selection = (state = {}, action) => {
  switch (action.type) {
    case ANS.SELECTION_STARTS: {
      const { rowIndex: y1, columnIndex: x1 } = action.payload
      return { x1, y1 }
    }
    case ANS.SELECTION_ENDS:
    case ANS.SELECTION_EXPANDS: {
      const { rowIndex: y2, columnIndex: x2 } = action.payload
      return { ...state, x2, y2 }
    }
    case ANS.SET_SELECTION:
      return action.payload
  }
  return state
}

export const headers = (state = [], action) => {
  switch (action.type) {
    case ANS.SET_DATA:
      return action.payload.headers
  }
  return state
}

export const editContent = (state = null, action) => {
  switch (action.type) {
    case ANS.SET_EDIT_CONTENT:
      return action.payload == null || action.payload === undefined
        ? ''
        : action.payload
    case ANS.START_EDIT:
      return action.payload.content == null ||
        action.payload.content === undefined
        ? ''
        : action.payload.content
    case ANS.COMMIT_EDIT:
    case ANS.CANCEL_EDIT:
      return null
  }
  return state
}

export const editInitKey = (state = null, action) => {
  switch (action.type) {
    case ANS.SET_EDIT_CONTENT:
      return null
    case ANS.START_EDIT:
      return action.payload.initKey == null ||
        action.payload.initKey === undefined
        ? ''
        : action.payload.initKey
    case ANS.COMMIT_EDIT:
    case ANS.CANCEL_EDIT:
      return null
  }
  return state
}

export const editPosition = (state = null, action) => {
  switch (action.type) {
    case ANS.START_EDIT:
      return {
        rowIndex: action.payload.rowIndex,
        columnIndex: action.payload.columnIndex,
      }
    case ANS.COMMIT_EDIT:
    case ANS.CANCEL_EDIT:
      return null
  }
  return state
}

const defaultEditCommitRedcuer = createCommitEditReducer(
  ({ existingData, prop, value }) => ({ ...existingData, [prop]: value })
)

const defaultPasteDataReducer = createPasteDataReducer(
  ({ existingData, updateData }) => ({ ...existingData, ...updateData })
)

export const data = (state = [], action) => {
  switch (action.type) {
    case ANS.SET_CONTENT:
      return action.payload
    case ANS.SET_DATA:
      return action.payload.data
    case ANS.PASTE_DATA:
      return defaultPasteDataReducer(state, action)
    case ANS.COMMIT_EDIT:
      return defaultEditCommitRedcuer(state, action)
  }
  return state
}

export const headerMap = (state = {}, action) => {
  switch (action.type) {
    case ANS.SET_DATA:
      return action.payload.headerMap
  }
  return state
}
